/**
 * @fileoverview Toast Component
 * @author Matt Convente (mconvente@yext.com)
 */
goog.declareModuleId('yext.ui.components.toast');

import {yext} from '/ui/lib/msg';

let showToastTimeout;
const toastPlaceholderElem = document.createElement('div');

/**
 * @param {React.ReactNode} message
 * @param {boolean} isStatic
 * @param {{
 *   onClose?: (function(): void),
 * }=} additionalProps
 */
export function showSuccessToast(message, isStatic = false, additionalProps = {}) {
  showToast(message, 'success', isStatic, additionalProps);
}

/**
 * @param {React.ReactNode} message
 * @param {boolean} isStatic
 * @param {{
 *   onClose?: (function(): void),
 * }=} additionalProps
 */
export function showWarningToast(message, isStatic = false, additionalProps = {}) {
  showToast(message, 'warning', isStatic, additionalProps);
}

/**
 * @param {React.ReactNode} message
 * @param {boolean} isStatic
 * @param {{
 *   onClose?: (function(): void),
 * }=} additionalProps
 */
export function showErrorToast(message, isStatic = false, additionalProps = {}) {
  showToast(message, 'error', isStatic, additionalProps);
}

/**
 * @param {React.ReactNode} message
 * @param {boolean} isStatic
 * @param {{
 *   onClose?: (function(): void),
 * }=} additionalProps
 */
export function showNeutralToast(message, isStatic = false, additionalProps = {}) {
  showToast(message, 'neutral', isStatic, additionalProps);
}

/**
 * @param {React.ReactNode} message
 * @param {string} useCase
 * @param {boolean} isStatic
 * @param {{
 *   onClose?: (function(): void),
 * }} additionalProps
 */
function showToast(message, useCase, isStatic, additionalProps) {
  toastPlaceholderElem.setAttribute('id', 'yext-toast__placeholder');
  document.body.appendChild(toastPlaceholderElem);

  ReactDOM.render(
    <Toast message={message} useCase={useCase} onClose={additionalProps.onClose}/>,
    toastPlaceholderElem,
  );

  if (!isStatic) {
    showToastTimeout = setTimeout(() => {
      hideToast();
    }, 6000);
  }
}

export function hideToast() {
  const toastElem = document.querySelector('.yext-toast');
  if (!toastElem) {
    clearTimeout(showToastTimeout);
    return;
  }
  toastElem.classList.remove('yext-toast--animating-show');
  toastElem.classList.add('yext-toast--animating-hide');
  toastElem.addEventListener('animationend', () => {
    ReactDOM.unmountComponentAtNode(toastPlaceholderElem);
  });
  clearTimeout(showToastTimeout);
}

/**
 * @param {{
 *   useCase: string,
 * }} props
 * @return {(string|null)}
 */
function getToastClasses({
  useCase,
}) {
  let toastClasses = 'yext-toast yext-toast--animating-show unittest-yext-toast';

  if (useCase === 'success') {
    toastClasses += ' yext-toast--success';
  } else if (useCase === 'warning') {
    toastClasses += ' yext-toast--warning';
  } else if (useCase === 'error') {
    toastClasses += ' yext-toast--error';
  } else if (useCase === 'neutral') {
    toastClasses += ' yext-toast--neutral';
  }

  return toastClasses;
}

/**
 * @param {{
 *   message: React.ReactNode,
 *   useCase: string,
 *   onClose?: (function(): void),
 * }} props
 * @return {React.ReactElement}
 */
function Toast({
  message,
  useCase,
  onClose,
}) {
  const closeIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="20" height="20" viewBox="0 0 20 20"
      aria-hidden
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M17.5 4L16 2.5l-6 6-6-6L2.5 4l6 6-6 6L4 17.5l6-6 6 6 1.5-1.5-6-6z"
      />
    </svg>
  );

  return (
    <div className={getToastClasses({useCase})}>
      <span className="unittest-yext-toast-message">{message}</span>
      <button
        type="button"
        className="yext-toast__close-button"
        aria-label={yext.msg('Dismiss')}
        onClick={() => {
          hideToast();
          if (onClose) {
            onClose();
          }
        }}
      >
        {closeIcon()}
      </button>
    </div>
  );
}
